(() => {
  const init = (root) => {
    if (root.dataset.jfCarouselReady) return;
    root.dataset.jfCarouselReady = 'true';
    const viewport = root.querySelector('[data-jf-carousel-viewport]');
    const slides = Array.from(root.querySelectorAll('.jf-event-product-hero__slide'));
    if (!viewport || slides.length < 2) return;
    const prev = root.querySelector('[data-jf-carousel-prev]');
    const next = root.querySelector('[data-jf-carousel-next]');
    const count = root.querySelector('[data-jf-carousel-count]');
    let active = 0;
    slides[0].classList.add('is-active');
    const update = () => {
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      active = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft + slide.offsetWidth / 2 - center) < Math.abs(slides[best].getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft + slides[best].offsetWidth / 2 - center) ? i : best, 0);
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
    };
    const go = (index) => {
      const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
      viewport.scrollTo({ left: viewport.scrollLeft + slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left - (viewport.clientWidth - slide.offsetWidth) / 2, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    prev?.addEventListener('click', () => go(active - 1));
    next?.addEventListener('click', () => go(active + 1));
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  const initAll = () => document.querySelectorAll('[data-jf-hero-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
